import { Scene } from "three";
import {
  Collada,
  ColladaLoader
} from "three/examples/jsm/loaders/ColladaLoader";

class Loader {
  public loader: ColladaLoader;

  constructor() {
    this.loader = new ColladaLoader();
  }

  public loadModel(modelPath: string, onLoad: (scene: Scene) => void): void {
    this.loader.load(modelPath, (collada: Collada) => {
      onLoad(collada.scene);
    });
  }
}

export default Loader;
